export default __webpack_public_path__ + "static/media/fakieh.d8c9b050.jpg";